document.addEventListener('DOMContentLoaded', function () {
  console.log("BOLD LOAD")
  setTimeout(function(){
    var optionSets = document.querySelectorAll('.bold_option.bold_option_swatch');
  
    optionSets.forEach(function (optionSet) {
      var titleElement = optionSet.querySelector(' .bold_option_title');
      var helpTextElement = optionSet.querySelector('.bold_help_text small');
  
      if (titleElement && helpTextElement) {
        var helpText = helpTextElement.textContent;
        var appendedText = document.createElement('span');
       appendedText.className = "bold_help_text small boldHelpText"
        appendedText.textContent = ' - ' + helpText;
        titleElement.appendChild(appendedText);
      }
    });
  },800)
});
